import { CallsWorkspace } from "@/features/calls";

export default function CallsPage() {
  return <CallsWorkspace />;
}
